import {
  appModuleCatalogSchema,
  patchModulesRequestSchema,
  patchModulesResponseSchema,
  type AuthUser,
  type PatchModulesRequest,
} from '@gb-ticket/shared-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { meQueryKey } from '@/features/auth/use-me';
import { apiFetch } from '@/lib/api';

export const systemModulesQueryKey = ['settings', 'modules'] as const;

export function useSystemModulesCatalog(enabled = true) {
  return useQuery({
    queryKey: systemModulesQueryKey,
    queryFn: () => apiFetch('/settings/modules', appModuleCatalogSchema),
    enabled,
  });
}

export function usePatchSystemModules() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: PatchModulesRequest) =>
      apiFetch('/settings/modules', patchModulesResponseSchema, {
        method: 'PATCH',
        body: JSON.stringify(patchModulesRequestSchema.parse(body)),
      }),
    onSuccess: async (result) => {
      queryClient.setQueryData(systemModulesQueryKey, {
        items: result.items,
        updatedAt: result.updatedAt,
        enabledModules: result.enabledModules,
      });
      queryClient.setQueryData<AuthUser | null>(meQueryKey, (current) =>
        current ? { ...current, enabledModules: result.enabledModules } : current,
      );
      await queryClient.invalidateQueries({ queryKey: meQueryKey });
      await queryClient.invalidateQueries({ queryKey: systemModulesQueryKey });
    },
  });
}
